import { Observable } from 'rxjs';

import type { TransactionsFilter } from '@coin-depo-types';

export interface GetTransactionsParams {
  filter?: TransactionsFilter;
  page?: number;
  per_page?: number;
  desc?: 0 | 1;
  lang?: string;
  trx_user_id?: string;
}

export interface TransactionsFacade {
  canCancelTransaction?: boolean;

  getTransactions(
    params: GetTransactionsParams
  ): Observable<any>;

  getTransactionsCsvList(
    params: GetTransactionsParams
  ): Observable<any>;

  cancelTransaction(trxid: string): Observable<any>;
}